import { useEffect, useRef, useState } from "react"

export function useHeight<T = any> () {
  const [height, setHeight] = useState<number>(0)
  const ref = useRef<T>(null)

  useEffect(() => {
    if (ref.current) {
      const target = ref.current
      setHeight((target as any).offsetHeight)
    }
  }, [ref])
  
  return {ref, height}
}

export default useHeight;